---
title: FAQ
lede: Short answers to the questions people ask first.
order: 55
part: Help
---

### Can the agent reach my real repositories?

Not from a micro-VM. Each repository is copied into the sandbox; nothing is mounted. A session placed on this computer works in a `git worktree` of your repository instead. See [Where a session runs](/placement).

### Does my Claude subscription token go into the sandbox?

No. It stays on your computer and is added to requests as they leave. A Codex ChatGPT login is copied into the sandbox; use an OpenAI API key if it must not be. See [Signing the agents in](/agents).

### Does my code leave this computer?

Not unless you push it or share a workspace with an [organization](/organization). Airlock itself contacts the licence service (your key and a computer fingerprint, on each [update](/updates) check) and your agent's provider. Crash reports stay on your computer. What a session may reach is the allowlist in [Network](/network).

### What happens if I quit while a session is working?

It keeps working. The menu says so: **Quit Airlock (sessions keep running)**. Reopening Airlock reattaches to the sandboxes.

### Can two sessions work on the same repository?

Yes. Each has its own copy and its own `session/<id>` branch. You merge them one at a time.

### Why is my session not starting?

Usually a ceiling: **Sessions working at once** or **Sessions open at once**. The task waits at the top of **To do**. See [Defaults and limits](/limits).

### Can I edit the code while the agent works?

Yes, in [Files](/files), which writes into the sandbox. Editing your own checkout is fine too; once you commit on the source branch, [Sync](/sync) brings those commits into the session.

### Does Airlock change my git config or install tools?

No. It never writes your git config or reads `~/.config/gh`. The tools it manages, such as the GitHub CLI and the tunnel agent, live in its own [data folder](/data-folder) and never replace yours.

### How many machines does a licence cover?

Two. **Settings › License** shows them under **Machines**. A machine unseen for a month frees its slot.

### Which systems does it run on?

macOS, on a Mac with Apple silicon. There is no Windows or Linux version. See [Getting started](/getting-started).

### Where do I report a problem?

Email [support@tryairlock.app](mailto:support@tryairlock.app) with **Settings › About**, and the Diagnostics Overview (`⌘⌥D`) if it reports anything.
